module.exports = __webpack_public_path__ + "static/img/ent-detail-16.eb1c0e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-16.jpg
// module id = Xy5R
// module chunks = 52